<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { watermark } from "@/utils";

export default {
	computed: {
		...mapGetters(["userInfo"])
	},
	watch: {
		userInfo: {
			handler(val) {
				const needWatermark = process.env.VUE_APP_WATERMARK === "true";

				if (needWatermark) {
					const projectName = process.env.VUE_APP_PROJECT_NAME;
					const mark = `${projectName}${val.username ? `-${val.username}` : ""}${val.nickname ? `-${val.nickname}` : ""}-${new Date().toLocaleString()}`;

					watermark.set(mark);
				}
			},
			immediate: true,
			deep: true
		}
	}
};
</script>

<style lang="scss">
#app {
	width: 100%;
	height: 100%;
}
</style>
